import React, { useRef } from "react";
import { Label, Input } from "reactstrap";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import { Container, Grid, Typography, Button, TextField,MenuItem,Select } from "@mui/material";
import {
  useSendDispatchDocMutation,
  useGetDispatchStockAddressesQuery,
  useGetDispatchAllDocumentsQuery,useGetInvoiceAddressInfoQuery
} from "./ProcurementApiSlice";
import { DispatchAllDoc } from "./DispatchAllDoc";

const SellerDispatch = ({ FullList, user_id, refetch, handleClose, value,  stockUserId,stockCropId }) => {
  const weighbridgeRef = useRef(null);
  const mandiDocumentRef = useRef(null);
  const transporterBiltyRef = useRef(null);
  const eWayBillRef = useRef(null);
 
  let procCode =
    FullList?.entity_type === "Seller"
      ? FullList?.trade_procCode
      : FullList?.ProcCode;

  const {
    data: getDispatchAddress,
    refetch: refetchAddress,
  } = useGetInvoiceAddressInfoQuery({stockUserId,stockCropId});
  const {
    data: AddResponse,
    refetch: refetchAddResponse,
  } = useGetDispatchAllDocumentsQuery(procCode);
  const [dispatch] = useSendDispatchDocMutation();
  const [dispatchAddresses, setDispatchAddresses] = useState([]);
  const [remainingQuantity, setRemainingQuantity] = useState(0);
  const [selectedAddresses, setSelectedAddresses] = useState([]);
  const [currentAddress, setCurrentAddress] = useState("");
  const [currentQuantity, setCurrentQuantity] = useState("");
  useEffect(() => {
    if (getDispatchAddress) {
      setDispatchAddresses(getDispatchAddress?.data);
    }
  }, [getDispatchAddress]);
  const [formData, setFormData] = useState({
    quantity: "",
    weighbridge: "",
    mandiDocument: "",
    transporterBilty: "",
    eWayBill: "",
    remarks: "",
    stock_location: "",
    id: "",
    expected_delivery_date: "",
  });
  const [loading, setLoading] = useState(false);
  console.log("AddResponse",AddResponse)
  
  const handleChange = (field, event) => {
    const { type, value, files } = event.target;
    console.log("field",field)
    if (type === "file") {
      if (field === "mandiDocument") {
          setFormData((prevData) => ({
            ...prevData,
            [field]: [...(prevData[field] || []), ...files],
          }));
         }else {
          setFormData((prevData) => ({
            ...prevData,
            [field]: files[0], // Set single file
          }));
        }
      
    } else {
      if (field === "quantity") {
        if (Number(value) > remainingQuantity) {
          toast.error("Quantity cannot exceed available stock.");
          return;
        }
      }
      setFormData((prevData) => ({
        ...prevData,
        [field]: value,
      }));
    }
  
   
  };
  
  const handleFormSubmit = (event) => {
    event.preventDefault();
    setLoading(true);
       let finalData = dispatchAddresses?.filter((item) => item.id === currentAddress)
    const formPayload = new FormData();
    formPayload.append("entity_type", "Seller");
    formPayload.append("user_id", user_id);
    formPayload.append("weightbridge_slip", formData.weighbridge);
    formPayload.append("eway_bill", formData.eWayBill);
    formPayload.append("transporter_billty", formData.transporterBilty);
    formPayload.append("quantity", parseFloat(currentQuantity));
    formPayload.append("category", "Procurement");
    formPayload.append(
      "ProcCode",
      FullList?.entity_type === "Seller"
        ? FullList?.trade_procCode
        : FullList?.ProcCode
    );
    formPayload.append("remark", formData.remarks);
    formPayload.append("stock_location", finalData[0].id);
    formPayload.append(
      "expected_delivery_date",
      formData.expected_delivery_date
    );
    if (formData.mandiDocument && formData.mandiDocument.length > 0) {
      formData.mandiDocument.forEach((file, index) => {
        formPayload.append(`mandi_document`, file);
      });
    }

    dispatch(formPayload)
      .unwrap()
      .then(async (data) => {
        toast.success("Document Uploaded Successfully !!");
        setFormData({
          quantity: "",
          weighbridge: "",
          mandiDocument: "",
          transporterBilty: "",
          eWayBill: "",
          remarks: "",
          stock_location: "",
          expected_delivery_date: "",
        });
        setCurrentQuantity("")
        setCurrentAddress("")
        if (weighbridgeRef.current) weighbridgeRef.current.value = "";
        if (mandiDocumentRef.current) mandiDocumentRef.current.value = "";
        if (transporterBiltyRef.current) transporterBiltyRef.current.value = "";
        if (eWayBillRef.current) eWayBillRef.current.value = "";

        setLoading(false);
        await refetch();
        refetchAddResponse();
        refetchAddress();
      })
      .catch((data) => {
        toast.error(`${data.data.message}`);
        setLoading(false);
      });
  };
  const handleChangeAddress=(e)=>{
  setCurrentAddress(e.target.value)
  let finalData = dispatchAddresses.filter((item) => item.id === e.target.value)
     setCurrentQuantity(finalData[0].quantity)
}

  return (
    <>
      <div>
        <Container
          maxWidth="lg"
          sx={{ bgcolor: "#f5f5f5", p: 3, borderRadius: 2 }}
        >
          <Grid container direction="column" spacing={3}>
            <Grid item xs={12}>
              <div>
                {AddResponse?.data[0]?.status === "Ready For Dispatch" ||
                AddResponse?.data[0]?.status === "Dispatched" ? (
                  ""
                ) : (
                  <form onSubmit={handleFormSubmit}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6} md={3}>
                        <Typography
                          variant="subtitle1"
                          className="text-primary text-underline"
                        >
                          Select Stock Location 
                        </Typography>
                        <Label>
                          (For generating dispatch){" "}
                          <span className="checkingcss">*</span>
                        </Label>
                          {console.log("dispatchAddresses",dispatchAddresses)}
                     
                         <Select
          labelId="address-select-label"
          value={currentAddress}
          onChange={(e) => handleChangeAddress(e)}
          label="Select Stock Location"
          className="bgWhite"
          fullWidth
        >
          {dispatchAddresses?.map((address) => (
            <MenuItem key={address.id} value={address.id}>
              {address.address}, {address.state}
            </MenuItem>
          ))}
        </Select>
                     
                      </Grid>
                      <Grid item xs={12} sm={6} md={3}>
                        <Typography
                          variant="subtitle1"
                          className="text-primary text-underline"
                        >
                          Quantity  <span className="checkingcss">*</span>
                        </Typography>
                       
                        <TextField
        label="Quantity"
        type="number"
        value={currentQuantity}
        onChange={(e) => setCurrentQuantity(e.target.value)}
        margin="normal"
        className="bgWhite"
        fullWidth
        required
      />
                      </Grid>
                      <Grid item xs={12} sm={6} md={3}>
                        <Typography
                          variant="subtitle1"
                          className="text-primary text-underline"
                        >
                          Upload Weighbridge Slip
                        </Typography>
                        <Label>
                          (PDF format only){" "}
                          <span className="checkingcss">*</span>
                        </Label>

                        <Input
                          type="file"
                          accept=".pdf"
                          onChange={(e) => handleChange("weighbridge", e)}
                          required
                          sx={{ fontSize: "15px" }}
                        />
                      </Grid>
                    
<Grid item xs={12} sm={6} md={3}>
  <Typography
    variant="subtitle1"
    className="text-primary text-underline"
  >
    Upload Mandi Chalan
  </Typography>
  <Label>(PDF format only)</Label>
  <Input
    type="file"
    accept=".pdf"
    multiple={formData.stock_location === "mandi"} 
    onChange={(e) => handleChange("mandiDocument", e)}
    sx={{ fontSize: "15px" }}
  />
  {formData?.mandiDocument && formData?.mandiDocument.length > 0 && (
    <Typography
      variant="body2"
      className="text-secondary mt-1"
    >
      {formData?.mandiDocument?.length} file(s) selected.
    </Typography>
  )}
</Grid>


                      <Grid item xs={12} sm={6} md={3}>
                        <Typography
                          variant="subtitle1"
                          className="text-primary text-underline"
                        >
                          Upload Transporter Bilty
                        </Typography>
                        <Label>(PDF format only)</Label>
                        <Input
                          type="file"
                          accept=".pdf"
                          onChange={(e) => handleChange("transporterBilty", e)}
                          sx={{ fontSize: "15px" }}
                          ref={transporterBiltyRef}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={3}>
                        <Typography
                          variant="subtitle1"
                          className="text-primary text-underline"
                        >
                          Upload E-way Bill
                        </Typography>
                        <Label>(PDF format only)</Label>
                        <Input
                          type="file"
                          accept=".pdf"
                          onChange={(e) => handleChange("eWayBill", e)}
                          sx={{ fontSize: "15px" }}
                          ref={eWayBillRef}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={3}>
                        <Typography
                          variant="subtitle1"
                          className="text-primary text-underline"
                        >
                          Expected Delivery Date
                        </Typography>
                        <Label>
                          (For generating dispatch){" "}
                          <span className="checkingcss">*</span>
                        </Label>
                        <Input
                          type="date"
                          value={formData.expected_delivery_date}
                          onChange={(e) =>
                            handleChange("expected_delivery_date", e)
                          }
                          required
                          sx={{ fontSize: "15px" }}
                          min={new Date().toISOString().split("T")[0]}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <Typography
                          variant="subtitle1"
                          className="text-primary"
                        >
                          Remarks 
                        </Typography>
                        <TextField
                          placeholder="Type your remarks here"
                          multiline
                          rows={2}
                          fullWidth
                          sx={{ mt: 1, backgroundColor: "white" }}
                          value={formData.remarks}
                          onChange={(e) => handleChange("remarks", e)}
                        />
                      </Grid>
                    </Grid>
                    <Grid container justifyContent="flex-end" mt={3}>
                      <Button
                        variant="contained"
                        color="primary"
                        type="submit"
                        disabled={loading}
                      >
                        Submit
                      </Button>
                    </Grid>
                  </form>
                )}
              </div>
              <DispatchAllDoc
                procCode={FullList.trade_procCode}
                user_id={user_id}
                refetch={refetch}
                FullList={FullList}
                AddResponse={AddResponse}
                refetchAddResponse={refetchAddResponse}
                refetchAddress={refetchAddress}
              />
            </Grid>
          </Grid>
        </Container>
      </div>
    </>
  );
};
export default SellerDispatch;
